import React from 'react'
import './../Form.css'
import GridContainer from "../GridContainer/GridContainer";

const MultiImageUpload = props => {
    const {id, label, defaultImages, setDefaultImages, uploadImages, setUploadImages} = props;
    const updateUploadImages = (event) => {
        const files = Array.from(event.target.files);
        if(files) {
            files.forEach(file => {
                const previewUrl = URL.createObjectURL(file);
                const imageUpload = { file, previewUrl}
                setUploadImages(alreadySelected => [...alreadySelected, imageUpload]);
            });
        }
    }

    const deselectEventTypeImage = (id) => {
        setDefaultImages(defaultImages.filter(prop => prop.id !== id));
    }
    const deselectUploadImage = (file) => {
        setUploadImages(uploadImages.filter(prop => prop.file !== file));
    }

    return (
        <>
        {  label &&
            <div className="form-element">
                <label>{label}</label>
            </div>
        }
        <GridContainer itemsPerRow={3}>
            <label className="add-images-button">
                <div className="grid-image">
                    <i className="fa fa-plus add-images-icon"></i>
                </div>
                <input multiple style={{ display: 'none' }} id={id} type="file" accept="image/*" onChange={updateUploadImages}/>
            </label>
            { defaultImages && defaultImages.map(({ id, imageUrl }, index) =>
                <div className="grid-image" key={index}>
                    <i className="fa fa-times-circle remove-images-icon" onClick={() => deselectEventTypeImage(id)}></i>
                    <img src={imageUrl} alt='multipic' />
                </div>
            )}
            { uploadImages && uploadImages.map(({ file, previewUrl }, index) =>
                <div className="grid-image" key={index}>
                    <i className="fa fa-times-circle remove-images-icon" onClick={() => deselectUploadImage(file)}></i>
                    <img src={previewUrl} alt='multipic' />
                </div>
            )}
        </GridContainer>
        </>
    )
}

export default MultiImageUpload
